import { render, staticRenderFns } from "./CategorySelector.vue?vue&type=template&id=13893825&scoped=true"
import script from "./CategorySelector.vue?vue&type=script&lang=js"
export * from "./CategorySelector.vue?vue&type=script&lang=js"
import style0 from "./CategorySelector.vue?vue&type=style&index=0&id=13893825&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../common/temp/node_modules/.pnpm/vue-loader@15.11.1_qty7iymlffgpukvncpluvycwfu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13893825",
  null
  
)

export default component.exports